export const environment = {
  production: false,
  apiServerUrl: 'https://view.test.tada.dev/safetyMessage',
  refreshIntervalMillis: 5000,
  naverApiId: 'uy1gcew8du',
}
